const enumToObject = (enumType) => {
    const result = {};
    for (const key of Object.keys(enumType)) {
        result[key] = enumType[key];
    }
    return result;
};
export default enumToObject;
